<template>  
  <div>
    <q-card inline style="width: 280px">
      <q-card-title>
        <q-toolbar color="primary">
        <q-toolbar-title>
          {{$t('global.NewGeoRegion')}}
          <q-chip floating color="warning">{{$t('global.Under')}}: {{ Parent.Label }} </q-chip>
        </q-toolbar-title>
        </q-toolbar>
      </q-card-title>
      <q-card-separator />
      <q-card-main>
        <q-input v-model="geoRegionName" :stack-label="$t('global.Name')" />
        <q-select
          v-model="selectedGeoRegionType"
          :float-label="$t('global.GeoRegionType')"
          :options="optionsGeoRegionType"
         />  
        <div v-if="false">
          <q-select
            v-model="IdProduct"
            :float-label="$t('global.Product')"
            :options="optionsProduct"   
          />  
          <q-input v-model="weightFactor" type="number" :stack-label="$t('global.DistributionWeightFactor')" />
          <div v-if="false">
            <q-input v-model="groundType" :stack-label="$t('global.Ground')" />
            <q-input v-model="plantYear" type="number" :stack-label="$t('global.PlantingYear')" />
            <q-input v-model="plantDistanceCm" type="number" :stack-label="$t('global.PlantDistanceMeter')" />
            <q-input v-model="rowDistanceCm" type="number" :stack-label="$t('global.RowsWidthMeters')" />
            <q-input v-model="plantCapital" type="number" :stack-label="$t('global.PlantsCapital')" />
            <q-input v-model="amortisationYear" type="number" :stack-label="$t('global.AmortizationYear')" />
          </div>
        </div>  
        <q-input v-model="comment" type="textarea" :stack-label="$t('global.Comment')" />
        
        <p></p>
        <q-btn v-show="geoRegionName && weightFactor" @click="mapDraw()" color="secondary" size="sm" :label="$t('global.DrawOnMap')" />
      </q-card-main>
    </q-card>   
  </div>
</template>

<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SideDialogGeoRegionNew',
  data () {
    return {
      IdProduct: null,
      optionsProduct: [{value: 1, label: 'Wein1'},{value: 2, label: 'Wein2'}, {value: 3, label: 'Wein3'}],
      geoRegionName: null,
      selectedGeoRegionType: 1,
      optionsGeoRegionType: [],
      form: {
        SessionId: null,
        action: 'InsertGeoRegion',
      },
      groundType: null,
      weightFactor: 1,
      plantYear: null,
      plantDistanceCm: null,
      rowDistanceCm: null,
      plantCapital: null,
      amortisationYear: null,
      comment:null,
    }
  },
  methods: {
    mapDraw(){
      eventBus.$emit('drawNewGeoRegion', this.Parent.IdParent)
    },
    loadProduct(){
      
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getProduct"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          console.log(response)
          if(response.status == 200){ 
            this.optionsProduct = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {        
        this.$q.notify('Something Wrong.')      
        console.log(e);
      })
    },   
  },
  watch: {
    Parent: function (val) {
      this.IdProduct = null //Empty Produc Selection when new Parent
    },
  },
  props: ['Parent'],
  created () {
    eventBus.$on('insertPolygon', (data) => {
      var poslist
        data.forEach(cords => {
          poslist = cords
          cords.forEach(cord => {           
          })
        })
        
        var insertGeoRegion = { IdGeoRegionParent: this.Parent.IdParent, Description: this.geoRegionName,  
          PosList: poslist, IdGeoRegionType: this.selectedGeoRegionType, groundType: this.groundType,
          plantYear: this.plantYear, plantDistanceCm: this.plantDistanceCm, rowDistanceCm: this.rowDistanceCm,
          plantCapital: this.plantCapital, amortisationYear: this.amortisationYear, comment: this.comment, 
          WeightFactor: this.weightFactor }
        
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "InsertGeoRegion"
        this.form.geo_region = insertGeoRegion
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
                if(response.data == "OK"){
                  eventBus.$emit('removeAllObjects', null)
                  eventBus.$emit('loadGeoRegion', true) //set no show to true to not show the objects after reloading the data
                  eventBus.$emit('loadDialog', 'SideDialogWelcome') // to remove the current dialog
                  eventBus.$emit('closeDialog', null)
                  this.$q.notify({ message: this.$t('global.NewEntry'), type: 'positive' })
                }
                else{
                    this.$q.notify('Something Wrong.')

                }
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    }),
    //Load Geo Region Type Descriptions
    this.form.SessionId = this.$store.state.session.SessionId
    this.form.action = "getGeoRegionTypeDescription"
    this.form.IdLanguage = this.$store.state.session.IdLanguage
    axios.post(this.$apiUrl,
    qs.stringify(this.form),
    {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(response => {
        console.log(response)
        if(response.status == 200){ 
          this.optionsGeoRegionType = response.data
        }
        else{
            this.$q.notify('Something Wrong.')
        }
    })
    .catch(e => {        
      this.$q.notify('Something Wrong.')      
      console.log(e);
    })
  },

}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}



</script>

<style>
</style>
